import { render, staticRenderFns } from "./Conflicts.vue?vue&type=template&id=ed6024e4&"
import script from "./Conflicts.vue?vue&type=script&lang=js&"
export * from "./Conflicts.vue?vue&type=script&lang=js&"
import style0 from "./Conflicts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports